import { getLocalApi } from "./localApi";
import { ProductCategory } from "app/shared/model";
import apiConfig from "app/api/apiConfig.json";

export async function getAllProductCategories() : Promise<ProductCategory[]> {
    const localApi = await getLocalApi();

    return await localApi.fetchList(apiConfig.reference_data_product_category, (dto:any) => ({
        name: dto.name,
        id: dto.id,
        active: dto.active,
        divisionId: dto.divisionId,
        createdBy: dto.createdBy,
        lastModifiedBy: dto.lastModifiedBy
    }), 'Unable to fetch product categories')
}